export default __webpack_public_path__ + "static/media/sunatIllustration.c026705a.svg";